import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import Classes from './Navbar.module.css';
import Logo from '../Logo/Logo';
import { scrollToElement } from '../../../../../utils/scrollToElement';
import { useSelector } from 'react-redux';
import StoreSelectionPopup from '../../../../GlobalComp/Footer/StoreSelectionPopup';

const IOS_APP_LINK =
  'https://apps.apple.com/us/app/fuelclubs/id6753362541';
const ANDROID_APP_LINK =
  'https://play.google.com/store/apps/details?id=com.devzona.fuelclubs';

export default function Navbar({ isShadow = false }) {
  const navigateTo = useNavigate();
  const location = useLocation();
  const [activePage, setActivePage] = useState(location.pathname);
  const { user } = useSelector((s) => s?.auth || {});

  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );
  const [showStorePopup, setShowStorePopup] = useState(false);

  useEffect(() => {
    setActivePage(location.pathname);
  }, [location.pathname]);

  const handleScrollOrNavigate = (id, pathTo, offset = 0) => {
    if (location.pathname !== pathTo) {
      navigateTo(pathTo, { state: { scrollTo: { id, offset } } });
    } else {
      scrollToElement(id, offset);
    }
  };

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = width < 768;

  const handleButtonClick = () => {
    // if (isMobile) {
    //   setShowStorePopup(true);
    //   return;
    // }

    // Desktop flow
    if (user) {
      navigateTo('/');
    } else {
      navigateTo('/login');
    }
  };

  const handleStoreSelect = (platform) => {
    const url = platform === 'ios' ? IOS_APP_LINK : ANDROID_APP_LINK;
    window.open(url, '_blank');
  };

  return (
    <>
      <motion.div
        className={Classes.navbar}
        style={{
          boxShadow: isShadow ? '0px 4px 20px rgba(0, 0, 0, 0.1)' : '',
        }}
      >
        <div style={{ display: 'flex' }}>
          <a
            href="/"
            style={{ textDecoration: 'none' }}
            className={Classes.logoMargin}
          >
            <div>
              <Logo alwaysShowText={true} />
            </div>
          </a>
        </div>
        <ul>
          {width > 480 && (
            <li
              onClick={() => handleScrollOrNavigate('membership', '/', 25)}
              className={Classes.navActive}
            >
              <h5> Memberships </h5>
            </li>
          )}
          <li
            onClick={() => { navigateTo('/how-it-works') }}
            className={Classes.navActive}
          >
            <h5>How it Works</h5>
          </li>
          <li
            onClick={() => handleScrollOrNavigate('faq', '/how-it-works', 0)}
            className={Classes.navActive}
          >
            <h5> FAQ </h5>
          </li>
          <li
            onClick={() => { navigateTo('/testimonials') }}
            className={Classes.navActive}
          >
            <h5> Testimonials </h5>
          </li>
        </ul>

        <div className={Classes.gridRight}>
          {user ? (
            <button
              type="button"
              onClick={handleButtonClick}
              className={Classes.startBtn}
            >
              <h5> Dashboard </h5>
            </button>
          ) : (
            <button
              type="button"
              onClick={handleButtonClick}
              className={Classes.startBtn}
            >
              <h5> Login </h5>
            </button>
          )}
        </div>
      </motion.div>

      {/* Reusable popup */}
      <StoreSelectionPopup
        open={showStorePopup}
        onClose={() => setShowStorePopup(false)}
        onSelect={handleStoreSelect}
      />
    </>
  );
}
